import { Pipe, PipeTransform } from '@angular/core';
import { environment } from 'src/environments/environment';

@Pipe({
  name: 'mapUrlForImg'
})
export class MapUrlForImgPipe implements PipeTransform {
  store = JSON.parse(sessionStorage.getItem('store'));
  transform(value: string): unknown {
    if(value) {
      let xTenName = value.split('.');
      let imgName = xTenName[0];
      let XTen = xTenName[xTenName.length - 1];
      value = `${environment.badgesImageUrl}${this.store['id']}/` + imgName + '_xs.' + XTen;
      return value;
    }
  }

}
